import React from 'react';
import useMeNavigator from '../meNavigator';
import { Button, ButtonColor, ButtonSize } from 'ui-builder';

export default function OpenUpdateProfilePageButton() {
  const meNavigator = useMeNavigator();
  return (
    <Button
      text="Profile"
      size={ButtonSize.MEDIUM}
      color={ButtonColor.BLUE}
      isFilled
      onClick={meNavigator.openUpdateProfilePage}
    />
  );
}
